<template>
  <div>
    
    <div class="row">
        <div class="col-12">
          <div v-if="companyObject.title !== ''" class="mt-3">
            <span v-if="!companyObject.logoPath" style="line-height:40px;font-size:25px;">{{ companyObject.tradeTitle }}</span>
            <span v-else>
              <img :src="companyObject.logoPath" :alt="companyObject.tradeTitle" height="70px">
              <!-- <span style="line-height:70px;font-size:25px;margin-left:10px;">{{ companyObject.tradeTitle }}</span> -->
            </span>
            <a class="ml-3" href="javascript:void(0);" title="refresh list" @click="fetchTopicsTree">refresh&nbsp;<i class="icomoon-loop2"></i></a>
          </div>
          <div class="mt-3 alert alert-success"><i class="icomoon-info">&nbsp;</i>Here you can prepare and configure the custom topics and criteria that will be attached to the ESG data of the company</div>
          <div class="mt-3">
            <div class="">
              <div class="row">
                <div v-for="(pillr, index) in pillars" :key="index" class="col-12 col-md-6 col-xl-3">
                  <div :class="['card','pl-2','pr-2','pb-2','bg-' + pillr]">
                    <ul class="topics_tree mt-4">
                      <tree-item
                        class="tree-item"
                        :item="topicsTree[pillr]"
                        @treeItemDeleted="initDeleteModal"
                        @treeItemEdited="initTopicModal"
                        @criteriaShow="initCriteriaModal"
                        :show-custom-criteria-count="true"
                        :is-custom="true"
                        :is-editable="actions.canUserUpdateTopic"
                        :is-deletable="actions.canUserDeleteTopic"
                      ></tree-item>
                    </ul>
                    <div class="text-center"><button v-if="actions.canUserCreateTopic" class="btn btn-sm btn-primary" @click="topicObject.pillar=pillr;initTopicModal(null);">add custom topic</button></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    
    <modal v-if="actions.canUserUpdateTopic" name="update-custom-topic-modal" :draggable="true" height="auto" :scrollable="true" :clickToClose="false">
      <div style="position:relative;" class="p-3">
        <div style="position: absolute; top: 5px; right: 5px;">
          <button class="btn btn-sm btn-neutral btn-border" @click="$modal.hide('update-custom-topic-modal')">&times;</button>
        </div>
        <div>
          <h5 v-if="topicObject.id" class="card-title mb-4" style="margin-top:5px;">Edit&nbsp;Custom&nbsp;Topic</h5>
          <h5 v-else class="card-title mb-4" style="margin-top:5px;">New&nbsp;Custom&nbsp;Topic</h5>
        </div>
        <div>
          <div class="form-group">
            <label class="control-label">Pillar</label>
            <div v-if="topicObject.id" class="input-group">
              <select class="form-control" v-model="topicObject.pillar" :disabled="true" @change="topicObject.parentId = null">
                <option v-for="(item, index) in pillars" :key="index" :value="item">
                    {{ item }}
                </option>
              </select>
              <span class="input-group-append">
                <button type="button" class="btn btn-default btn-sm" disabled>Save</button>
              </span>
            </div>
            <select v-else class="form-control" v-model="topicObject.pillar" :disabled="true" @change="topicObject.parentId = null">
                <option v-for="(item, index) in pillars" :key="index" :value="item">
                    {{ item }}
                </option>
              </select>
          </div>
          <div class="form-group">
            <label class="control-label">Title*</label>
            <div v-if="topicObject.id" class="input-group">
              <input type="text" class="form-control" v-model.trim="topicObject.title">
              <div class="input-group-append">
                <button type="button" class="btn btn-default btn-sm" @click="saveTopicTitle">Save</button>
              </div>
            </div>
            <input v-else type="text" class="form-control" v-model.trim="topicObject.title">
          </div>
          <div class="form-group">
            <label class="control-label">Parent</label>
            <div v-if="topicObject.id" class="input-group">
              <select class="form-control" v-model="topicObject.parentId">
                <option :value="null">No parent</option>
                <option v-for="(item, index) in topicsFlat[topicObject.pillar]" :key="index" :value="item.id" :disabled="item.id == topicObject.id">
                    {{ item.title }}
                </option>
              </select>
              <span class="input-group-append">
                <button type="button" class="btn btn-default btn-sm" @click="saveTopicParent">Save</button>
              </span>
            </div>
            <select v-else class="form-control" v-model="topicObject.parentId">
                <option :value="null">No parent</option>
                <option v-for="(item, index) in topicsFlat[topicObject.pillar]" :key="index" :value="item.id" :disabled="item.id == topicObject.id">
                    {{ item.title }}
                </option>
            </select>
          </div>
        </div>
        <hr>
        <div class="text-center">
          <button class="btn btn-neutral" @click="$modal.hide('update-custom-topic-modal');">Close</button>
          <button v-if="!topicObject.id" class="btn btn-default ml-2" @click="createTopic">Save</button>
        </div>
      </div>
    </modal>
    <modal v-if="actions.canUserUpdateTopic" name="criteria-custom-topic-modal" :draggable="true" height="auto" :scrollable="true" :clickToClose="false">
      <div style="position:relative;" class="p-3">
        <div style="position: absolute; top: 5px; right: 5px;">
          <button class="btn btn-sm btn-neutral btn-border" @click="$modal.hide('criteria-custom-topic-modal')">&times;</button>
        </div>
        <div>
          <h5>Custom Criteria - {{ topicObject.title }}</h5>
        </div>
        <div>
          <div>
            <div class="mb-3">
              <button v-if="actions.canUserCreateCriterion" class="btn btn-default btn-sm" @click="initCriterionModal(null)">New&nbsp;Criterion</button>
            </div>
            <div class="table-responsive" v-if="topicObject.criteriaDtos.length>0">
              <table class="table-bordered criteria-table">
                <tbody>
                  <tr v-for="(item, index) in topicObject.criteriaDtos" :key="index">
                    <td>{{ item.order }}</td>
                    <td>{{ item.title }}</td>
                    <td style="width: 75px;">
                      <span v-if="actions.canUserUpdateCriterion" @click="initCriterionModal(item)" class="edit-criterion" title="edit"><i class="icomoon-pencil"></i></span>
                      <span v-if="actions.canUserDeleteCriterion" @click="initDeleteCriterionModal(item)" class="delete-criterion" title="delete"><i class="icomoon-bin ml-2"></i></span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>No Criteria found</div>
          </div>
        </div>
        <div class="text-center">
          <button class="btn btn-neutral" @click="$modal.hide('criteria-custom-topic-modal');">Close</button>
        </div>
      </div>
    </modal>
    <modal v-if="actions.canUserDeleteTopic" name="delete-custom-topic-modal" :draggable="true" height="auto" :scrollable="false" :clickToClose="false">
      <div style="position:relative;" class="p-3">
        <div style="position: absolute; top: 5px; right: 5px;">
          <button class="btn btn-sm btn-neutral btn-border" @click="$modal.hide('delete-custom-topic-modal')">&times;</button>
        </div>
        <div>
          <h5 class="text-center mt-2">Are you sure you want to delete <i>{{ topicObject.title }}</i>?</h5>
        </div>
        <div class="text-center">
          <button class="btn btn-neutral btn-border" @click="$modal.hide('delete-custom-topic-modal');">No</button>
          <button class="btn btn-danger" @click="deleteTopic">Yes</button>
        </div>
      </div>
    </modal>
    <modal v-if="actions.canUserDeleteCriterion" name="delete-custom-criterion-modal" :draggable="true" height="auto" :scrollable="false" :clickToClose="false">
      <div style="position:relative;" class="p-3">
        <div style="position: absolute; top: 5px; right: 5px;">
          <button class="btn btn-sm btn-neutral btn-border" @click="$modal.hide('delete-custom-criterion-modal')">&times;</button>
        </div>
        <div>
          <h5 class="text-center">Are you sure you want to delete custom criterion <i>{{ criterionObject.title }}?</i></h5>
        </div>
        <div class="text-center">
          <button class="btn btn-neutral" @click="$modal.hide('delete-custom-criterion-modal');">No</button>
          <button class="btn btn-danger" @click="deleteCriterion">Yes</button>
        </div>
      </div>
    </modal>
    <modal v-if="actions.canUserUpdateCriterion" name="update-custom-criterion-modal" :draggable="true" height="auto" :scrollable="true" :clickToClose="false">
      <div style="position:relative;" class="p-3">
        <div style="position: absolute; top: 5px; right: 5px;">
          <button class="btn btn-sm btn-neutral btn-border" @click="$modal.hide('update-custom-criterion-modal')">&times;</button>
        </div>
        <div>
          <h5 v-if="criterionObject.id">Edit&nbsp;Custom&nbsp;Criterion</h5>
          <h5 v-else>New&nbsp;Custom&nbsp;Criterion</h5>
        </div>
        <div>
          <div class="form-group">
            <label class="control-label">Title*</label>
            <div v-if="criterionObject.id" class="input-group">
              <input type="text" class="form-control" v-model.trim="criterionObject.title">
              <div class="input-group-append">
                <button v-if="forceSaveCriterionTitle" class="btn btn-warning btn-sm" @click="saveCriterionTitle(true)">Save (force)</button>
                <button v-else class="btn btn-default btn-sm" @click="saveCriterionTitle(false)">Save</button>
              </div>
            </div>
            <input v-else type="text" class="form-control" v-model.trim="criterionObject.title">
          </div>
          <div class="form-group">
            <label class="control-label">Topic*</label>
            <div v-if="criterionObject.id" class="input-group">
              <select class="form-control" v-model="criterionObject.customTopicId">
                <option v-for="(item, index) in topicsFlat[topicObject.pillar]" :key="index" :value="item.id">
                    {{ item.title }}
                </option>
              </select>
              <span class="input-group-append">
                <button type="button" class="btn btn-default btn-sm" @click="saveCriterionTopic">Save</button>
              </span>
            </div>
            <select v-else class="form-control" v-model="criterionObject.customTopicId">
                <option v-for="(item, index) in topicsFlat[topicObject.pillar]" :key="index" :value="item.id">
                    {{ item.title }}
                </option>
              </select>
          </div>
          <div class="form-group">
            <label class="control-label">Display Order (inside topic)*</label>
            <div v-if="criterionObject.id" class="input-group">
              <input type="text" class="form-control" v-model.trim="criterionObject.order">
              <div class="input-group-append">
                <button type="button" class="btn btn-default btn-sm" @click="saveCriterionOrder">Save</button>
              </div>
            </div>
            <input v-else type="text" class="form-control" v-model.trim="criterionObject.order">
          </div>
          <div class="table-responsive">
            <table class="table table-borderless mb-0">
              <tbody>
                <tr>
                  <td>
                    <label class="control-label">
                      <input type="checkbox" v-model="criterionObject.isDeprecated">
                      Is deprecated? (exclude from new questionnaires)
                    </label>
                  </td>
                  <td class="text-right">
                    <button v-if="criterionObject.id" type="button" class="btn btn-default btn-sm" @click="saveCriterionIsDeprecated">Save</button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label class="control-label">
                      <input type="checkbox" v-model="criterionObject.isNumericIndex" @change="handleIsNumericChanged">
                      Is numeric index? (expects numeric answer)
                    </label>
                  </td>
                  <td class="text-right">
                    <button v-if="criterionObject.id" type="button" class="btn btn-default btn-sm" @click="saveCriterionIsNumericIndex">Save</button>
                  </td>
                </tr>
                <tr>
                  <td style="border-top:none;">
                    <label class="control-label">
                      <input type="checkbox" v-model="criterionObject.metaDto.expectsBooleanAnswer" :disabled="!criterionObject.isNumericIndex">
                      Is boolean? (expects boolean answer 0 | 1)
                    </label>
                  </td>
                </tr>
                <tr>
                  <td style="border-top:none; padding-right: 5px; width:50%;">
                    <label class="control-label">Ideal value</label>
                    <input type="text" class="form-control" v-model.trim="criterionObject.metaDto.idealValue" :disabled="!criterionObject.isNumericIndex">
                  </td>
                  <td style="border-top:none; padding-left: 5px;">
                    <label class="control-label">Ideal direction</label>
                    <select class="form-control" :disabled="!criterionObject.isNumericIndex" v-model="criterionObject.metaDto.idealDirection">
                      <option :value="null">Choose ideal direction</option>
                      <option :value="'ascending'">ASCENDING</option>
                      <option :value="'descending'">DESCENDING</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <hr>
        <div class="text-center">
          <button class="btn btn-neutral" @click="$modal.hide('update-custom-criterion-modal');">Close</button>
          <button v-if="!criterionObject.id" class="btn btn-default" @click="createCriterion">Save</button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Api from "../api";
import TreeItem from "../components/TreeItem";
export default {
  name: "CustomTopics",
  components: {
    TreeItem
  },
  data () {
    return {
      pillars: ['environmental'],
      frameworks: ['nza'],
      topicsTree: {
        gri: {
          title: 'Custom GRI Topics',
          id: null,
          childrenDtos: []
        },
        environmental: {
          title: 'Custom Environmental Topics',
          id: null,
          childrenDtos: []
        },
        social: {
          title: 'Custom Social Topics',
          id: null,
          childrenDtos: []
        },
        governance: {
          title: 'Custom Governance Topics',
          id: null,
          childrenDtos: []
        },
        financial: {
          title: 'Custom Financial Topics',
          id: null,
          childrenDtos: []
        },
        general: {
          title: 'Custom General Topics',
          id: null,
          childrenDtos: []
        },
      },
      topicsFlat: {
        gri: [],
        environmental: [],
        social: [],
        governance: [],
        financial: [],
        general: []
      },
      topicObject: {
        id: null,
        title: '',
        companyId: parseInt(this.$route.params.companyId),
        parentId: null,
        pillar: 'environmental',
        criteriaDtos: []
      },

      criterionObject: {
        id: null,
        title: '',
        order: null,
        customTopicId: null,
        isDeprecated: false,
        isNumericIndex: false,
        metaDto: {
          idealValue: null,
          idealDirection: null,
          expectsBooleanAnswer: false
        }
      },

      companyObject: {
        title: "",
        tradeTitle: "",
        logoPath: ""
      },

      actions: {
        canUserCreateTopic: false,
        canUserDeleteTopic: false,
        canUserUpdateTopic: false,
        canUserCreateCriterion: false,
        canUserDeleteCriterion: false,
        canUserUpdateCriterion: false
      },

      forceSaveCriterionTitle: false
    }
  },
  mounted () {
    this.actions.canUserCreateTopic = this.$root.canUserDo(['custom_topic_create']);
    this.actions.canUserDeleteTopic = this.$root.canUserDo(['custom_topic_delete']);
    this.actions.canUserUpdateTopic = this.$root.canUserDo(['custom_topic_update']);
    this.actions.canUserCreateCriterion = this.$root.canUserDo(['custom_criterion_create']);
    this.actions.canUserDeleteCriterion = this.$root.canUserDo(['custom_criterion_delete']);
    this.actions.canUserUpdateCriterion = this.$root.canUserDo(['custom_criterion_update']);
    this.fetchFrameworks();
  },
  methods: {
    fetchFrameworks() {
      let self = this;
      Api.send('GET', '/frameworks', {}, false)
      .then((response) => {
        self.frameworks = response;
        self.fetchPillars();
      })
      .catch((err) => {
        
      });
    },
    fetchPillars() {
      let self = this;
      Api.send('GET', '/pillars', {}, false)
      .then((response) => {
        self.pillars = response;
        self.fetchCompany();
      })
      .catch((err) => {
        
      });
    },
    fetchCompany() {
      let self = this;
      Api.send("GET", "/companies/" + self.topicObject.companyId + "?with_industry=0&with_full_region_info=0&with_parent=0", {})
        .then((response) => {
          self.companyObject.title = response.title;
          self.companyObject.tradeTitle = response.tradeTitle;
          self.companyObject.logoPath = response.logoPath;
          this.fetchTopicsTree();
        })
        .catch((err) => {
          self.companyObject.title = '';
          self.companyObject.tradeTitle = '';
          self.companyObject.logoPath = '';
          self.$root.notifyy('danger', err.msg);
        })
        .finally(() => {
          
        });
    },
    fetchTopicsTree() {
      let self = this;
      self.topicsTree.gri.childrenDtos = [];
      self.topicsTree.environmental.childrenDtos = [];
      self.topicsTree.social.childrenDtos = [];
      self.topicsTree.governance.childrenDtos = [];
      self.topicsTree.financial.childrenDtos = [];
      self.topicsTree.general.childrenDtos = [];
      Api.send('GET', '/custom_topics/' + self.topicObject.companyId + '/all/tree?with_criteria=1', {})
      .then((response) => {
        self.topicsTree.gri.childrenDtos = response.gri;
        self.topicsTree.environmental.childrenDtos = response.environmental;
        self.topicsTree.social.childrenDtos = response.social;
        self.topicsTree.governance.childrenDtos = response.governance;
        self.topicsTree.financial.childrenDtos = response.financial;
        self.topicsTree.general.childrenDtos = response.general;
        self.registerTopicsFlat();
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
        self.topicsTree.gri.childrenDtos = [];
        self.topicsTree.environmental.childrenDtos = [];
        self.topicsTree.social.childrenDtos = [];
        self.topicsTree.governance.childrenDtos = [];
        self.topicsTree.financial.childrenDtos = [];
        self.topicsTree.general.childrenDtos = [];
      });
    },
    registerTopicsFlat() {
      this.topicsFlat.gri = [];
      this.topicsFlat.environmental = [];
      this.topicsFlat.social = [];
      this.topicsFlat.governance = [];
      this.topicsFlat.financial = [];
      this.topicsFlat.general = [];
      for (let i in this.topicsTree.gri.childrenDtos) {
        this.registerChildren(this.topicsTree.gri.childrenDtos[i], '', 'gri');
      }
      for (let i in this.topicsTree.environmental.childrenDtos) {
        this.registerChildren(this.topicsTree.environmental.childrenDtos[i], '', 'environmental');
      }
      for (let i in this.topicsTree.social.childrenDtos) {
        this.registerChildren(this.topicsTree.social.childrenDtos[i], '', 'social');
      }
      for (let i in this.topicsTree.governance.childrenDtos) {
        this.registerChildren(this.topicsTree.governance.childrenDtos[i], '', 'governance');
      }
      for (let i in this.topicsTree.financial.childrenDtos) {
        this.registerChildren(this.topicsTree.financial.childrenDtos[i], '', 'financial');
      }
      for (let i in this.topicsTree.general.childrenDtos) {
        this.registerChildren(this.topicsTree.general.childrenDtos[i], '', 'general');
      }
    },
    registerChildren(item, prefix, pillar) {
      this.topicsFlat[pillar].push({
        id: item.id,
        title: prefix + item.title
      });
      if (item.childrenDtos.length > 0) {
        for (let i in item.childrenDtos) {
          this.registerChildren(item.childrenDtos[i], prefix + ' + ', pillar)
        }
      }
    },
    createTopic() {
      let self = this;
      Api.send('POST', '/custom_topics/' + self.topicObject.companyId, {
        title: self.topicObject.title, 
        parentId: self.topicObject.parentId, 
        pillar: self.topicObject.pillar
      })
      .then((response) => {
        self.fetchTopicsTree();
        self.$root.notifyy('success', response.msg);
        self.topicObject.id = null;
        self.topicObject.title = '';
        self.topicObject.parentId = null;
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },
    initTopicModal(item) {
      if (item) {
        this.topicObject.id = item.id;
        this.topicObject.title = item.title;
        this.topicObject.parentId = item.parentDto.id;
        this.topicObject.pillar = item.pillarDto.title;
      } else {
        this.topicObject.id = null;
        this.topicObject.title = "";
        this.topicObject.parentId = null;
      }
      this.$modal.show('update-custom-topic-modal');
    },
    initDeleteModal(item) {
      if (!item.id) {
        return false;
      }
      this.topicObject.id = item.id;
      this.topicObject.title = item.title;
      this.topicObject.parentId = item.parentDto.id;
      this.topicObject.pillar = item.pillarDto.title;
      this.$modal.show('delete-custom-topic-modal');
    },
    deleteTopic () {
      let self = this;
      if (!self.topicObject.id) {
        return false;
      }
      Api.send('DELETE', '/custom_topics/' + self.topicObject.id, {})
      .then((response) => {
        self.fetchTopicsTree();
        this.$modal.hide('delete-custom-topic-modal');
        self.$root.notifyy('success', response.msg);
        this.topicObject.id = null;
        this.topicObject.title = '';
        this.topicObject.parentId = null;
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },
    saveTopicTitle() {
      let self = this;
      if (!self.topicObject.id) {
        return false;
      }
      Api.send('PATCH', '/custom_topics/' + self.topicObject.id + '/title', {title: self.topicObject.title})
      .then((response) => {
        self.fetchTopicsTree();
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },
    saveTopicParent() {
      let self = this;
      if (!self.topicObject.id) {
        return false;
      }
      Api.send('PATCH', '/custom_topics/' + self.topicObject.id + '/parent', {parentId: self.topicObject.parentId})
      .then((response) => {
        self.fetchTopicsTree();
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },
    initCriteriaModal(object) {
      const topicItem = object.item;
      const isCustom = object.isCustom;
      this.topicObject.id = topicItem.id;
      this.topicObject.title = topicItem.title;
      this.topicObject.pillar = topicItem.pillarDto.title;
      this.topicObject.criteriaDtos = (isCustom) ? topicItem.customCriteriaDtos : topicItem.criteriaDtos;
      this.$modal.show('criteria-custom-topic-modal');
    },
    createCriterion() {
      let self = this;
      Api.send('POST', '/custom_topics/' + self.criterionObject.customTopicId + '/custom_criteria', {
        title: self.criterionObject.title,
        order: self.criterionObject.order,
        isDeprecated: self.criterionObject.isDeprecated,
        isNumericIndex: self.criterionObject.isNumericIndex,
        idealValue: (self.criterionObject.isNumericIndex) ? self.criterionObject.metaDto.idealValue : null,
        idealDirection: (self.criterionObject.isNumericIndex) ? self.criterionObject.metaDto.idealDirection : null,
        expectsBooleanAnswer: (self.criterionObject.isNumericIndex) ? self.criterionObject.metaDto.expectsBooleanAnswer : false,
      })
      .then((response) => {
        self.fetchTopicsTree();
        self.$root.notifyy('success', response.msg);
        self.criterionObject.id = null;
        self.criterionObject.title = '';
        self.criterionObject.customTopicId = null;
        self.criterionObject.order = null;
        self.criterionObject.isDeprecated = false;
        self.criterionObject.isNumericIndex = false;
        self.criterionObject.metaDto.idealValue = null;
        self.criterionObject.metaDto.idealDirection = null;
        self.criterionObject.metaDto.expectsBooleanAnswer = false;
        self.$modal.hide('update-custom-criterion-modal');
        self.$modal.hide('criteria-custom-topic-modal');
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },
    initCriterionModal(item) {
      this.forceSaveCriterionTitle = false;
      if (item) {
        this.criterionObject.id = item.id;
        this.criterionObject.title = item.title;
        this.criterionObject.customTopicId = item.customTopicDto.id;
        this.criterionObject.order = item.order;
        this.criterionObject.isDeprecated = item.isDeprecated;
        this.criterionObject.isNumericIndex = item.isNumericIndex;
        this.criterionObject.metaDto.idealValue = item.metaDto.idealValue;
        this.criterionObject.metaDto.idealDirection = item.metaDto.idealDirection;
        this.criterionObject.metaDto.expectsBooleanAnswer = item.metaDto.expectsBooleanAnswer;
      } else {
        this.criterionObject.id = null;
        this.criterionObject.title = "";
        this.criterionObject.customTopicId = this.topicObject.id;
        this.criterionObject.order = null;
        this.criterionObject.isDeprecated = false;
        this.criterionObject.isNumericIndex = false;
        this.criterionObject.metaDto.idealValue = null;
        this.criterionObject.metaDto.idealDirection = null;
        this.criterionObject.metaDto.expectsBooleanAnswer = false;
      }
      this.$modal.show('update-custom-criterion-modal');
    },
    initDeleteCriterionModal(item) {
      this.forceSaveCriterionTitle = false;
      if (!item.id) {
        return false;
      }
      this.criterionObject.id = item.id;
      this.criterionObject.title = item.title;
      this.criterionObject.order = item.order;
      this.criterionObject.customTopicId = item.customTopicDto.id;
      this.criterionObject.isDeprecated = item.isDeprecated;
      this.criterionObject.isNumericIndex = item.isNumericIndex;
      this.criterionObject.metaDto.idealValue = item.metaDto.idealValue;
      this.criterionObject.metaDto.idealDirection = item.metaDto.idealDirection;
      this.criterionObject.metaDto.expectsBooleanAnswer = item.metaDto.expectsBooleanAnswer;
      this.$modal.show('delete-custom-criterion-modal');
    },
    deleteCriterion () {
      let self = this;
      if (!self.criterionObject.id) {
        return false;
      }
      Api.send('DELETE', '/custom_criteria/' + self.criterionObject.id, {})
      .then((response) => {
        self.fetchTopicsTree();
        self.$root.notifyy('success', response.msg);
        self.$modal.hide('delete-custom-criterion-modal');
        self.$modal.hide('criteria-custom-topic-modal');
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },
    saveCriterionTitle(force) {
      let self = this;
      if (!self.criterionObject.id) {
        return false;
      }
      let forceUrl = (force) ? '?force=1' : '';
      Api.send('PATCH', '/custom_criteria/' + self.criterionObject.id + '/title' + forceUrl, {title: self.criterionObject.title})
      .then((response) => {
        self.fetchTopicsTree();
        self.$root.notifyy('success', response.msg);
        self.$modal.hide('criteria-custom-topic-modal');
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
        if (err.data && err.data.requires_force) {
          self.forceSaveCriterionTitle = true;
        }
      });
    },
    saveCriterionTopic() {
      let self = this;
      if (!self.criterionObject.id) {
        return false;
      }
      Api.send('PATCH', '/custom_criteria/' + self.criterionObject.id + '/topic', {topicId: self.criterionObject.customTopicId})
      .then((response) => {
        self.fetchTopicsTree();
        self.$root.notifyy('success', response.msg);
        self.$modal.hide('criteria-custom-topic-modal');
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },
    saveCriterionOrder() {
      let self = this;
      if (!self.criterionObject.id) {
        return false;
      }
      Api.send('PATCH', '/custom_criteria/' + self.criterionObject.id + '/order', {order: self.criterionObject.order})
      .then((response) => {
        self.fetchTopicsTree();
        self.$root.notifyy('success', response.msg);
        self.$modal.hide('criteria-custom-topic-modal');
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },
    saveCriterionIsDeprecated() {
      let self = this;
      if (!self.criterionObject.id) {
        return false;
      }
      Api.send('PATCH', '/custom_criteria/' + self.criterionObject.id + '/is_deprecated', {isDeprecated: self.criterionObject.isDeprecated})
      .then((response) => {
        self.fetchTopicsTree();
        self.$root.notifyy('success', response.msg);
        self.$modal.hide('criteria-custom-topic-modal');
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },
    saveCriterionIsNumericIndex() {
      let self = this;
      if (!self.criterionObject.id) {
        return false;
      }
      Api.send('PATCH', '/custom_criteria/' + self.criterionObject.id + '/is_numeric_index', {
        isNumericIndex: self.criterionObject.isNumericIndex,
        idealValue: (self.criterionObject.isNumericIndex) ? self.criterionObject.metaDto.idealValue : null,
        idealDirection: (self.criterionObject.isNumericIndex) ? self.criterionObject.metaDto.idealDirection : null,
        expectsBooleanAnswer: (self.criterionObject.isNumericIndex) ? self.criterionObject.metaDto.expectsBooleanAnswer : false
      })
      .then((response) => {
        self.fetchTopicsTree();
        self.$root.notifyy('success', response.msg);
        self.$modal.hide('criteria-custom-topic-modal');
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },
    handleIsNumericChanged: function(event) {
      if (!event.target.checked) {
        this.criterionObject.metaDto.expectsBooleanAnswer = false;
      }
    }
  },
};
</script>
<style scoped>
.topics_tree {
  padding-left: 0;
  line-height: 2em;
  list-style-type: none;
  font-size: 1.2em;
}
.delete-criterion {
  cursor: pointer;
}
.edit-criterion {
  cursor: pointer; 
}
.criteria-table {
  width: 100%;
  margin-bottom: 20px;
}
.criteria-table td {
  vertical-align: top;
  white-space: normal;
  padding: 5px 10px;
  font-size: 21px;
  line-height: 35px;
}
.table-borderless td {
  padding: 5px 0px 5px 0px;
}
.bg-gri {
  background-color: rgb(0 123 211 / 13%);
}
.bg-environmental {
  background-color: rgb(45 206 137 / 13%);
}
.bg-social {
  background-color: rgb(255 214 0 / 13%);
}
.bg-governance {
  background-color: rgb(94 114 228 / 13%);
}
.bg-financial {
  background-color: rgb(255, 231, 221);
}
.bg-general {
  background-color: rgb(245, 246, 250);
}
</style>
